import { forEachOnObject } from '../../../lib/utilities';

export const subscribeToStores = onUpdate => stores => forEachOnObject(
    stores,
    store => store.addListener(onUpdate),
);
